$('.wco-social-share-inner.initialiy-hidden').removeClass('initialiy-hidden');

$('.wco-social-share-inner-button').on('click',function () {
   $('.wco-social-share-overlay').toggleClass('force-visible');
});

$('.wco-social-share-overlay a').on('click', function () {
   $('.wco-social-share-overlay').removeClass('force-visible');
});
